
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
interface Tree {
  root: TreeNode;
}

interface TreeNode {
  label: string;
  children: TreeNode[];
  expanded?: boolean;
}

@Component({
  selector: 'app-sl-tree',
  templateUrl: './sl-tree.component.html',
  styleUrls: ['./sl-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlTreeComponent {
  public data: Tree;
  public selectedTreeNode: TreeNode | null;

  // I initialize the app component.
  constructor(private cdr:ChangeDetectorRef) {

    this.selectedTreeNode = null;
    this.data = {
      root: {
        label: "first",
        children: [
          {
            label: "second-a",
            children: [
              {
                label: "third-first",
                children: [
                  {
                    label: "ferth",
                    children: [
                      {
                        label: "fiver",
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            label: "second-b",
            children: [
              {
                label: "third",
                children: []
              }
            ]
          }
        ]
      }
    }

  }

  // ---
  // PUBLIC METHODS.
  // ---

  // I select the given tree node, and log it to the console.
  public selectNode(node: TreeNode): void {
    node.expanded = !node.expanded;
    this.selectedTreeNode = node;

    console.group("Selected Tree Node");
    console.log("Label:", node.label);
    console.log("Children:", node.children.length);
    console.groupEnd();
    this.cdr.markForCheck();
    this.cdr.detectChanges();

  }

}
